import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ConfigService } from 'src/app/services/config.service';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-modal-points-info',
  templateUrl: './modal-points-info.page.html',
  styleUrls: ['./modal-points-info.page.scss'],
})
export class ModalPointsInfoPage implements OnInit {

  @Input() text;
  @Input() type;
  @Input() playerRanking;

  displayedColumns = ['position', 'name', 'num_responses']

  constructor(
    public modalController: ModalController,
    public configService: ConfigService,
    private analyticsService: AnalyticsService
  ) { 
    this.analyticsService.AnalyticsServiceModalView('points-info');
  }

  ngOnInit() {
    console.log(this.type, this.text, this.playerRanking);
    if (this.playerRanking.length > 0) {
      let counter = 1
      for (let player of this.playerRanking) {
        player.position = counter;
        counter++;
      }
    }
  }

  //Function to close modal
  closeModal() {
    this.modalController.dismiss();
  }
}
